import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DailyProgressItemsRequestDto } from 'src/api/FiretrolApiClient';
import { dailyProgressApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useCreateDailyProgress() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      jobId,
      request,
    }: {
      jobId: number;
      request: DailyProgressItemsRequestDto;
    }) => dailyProgressApiClient.createProgressItems(jobId, request),
    meta: { successMessage: 'Progress Updated!' },
    onSettled: (_data, _err, { jobId }) =>
      invalidateFor('dailyProgress.create', qc, { jobId }),
  });
}
